import moment from "moment";

export const sortByAlpha = (data, order) => {
  if (order) {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  } else {
    return data.sort((a, b) => b.label.localeCompare(a.label));
  }
};

export const sortByAmount = (data, order) => {
  const sumValues = (obj) => {
    const { Completed, Total } = obj;

    return Object.values({ Completed, Total }).reduce((a, b) => a + b, 0);
  };

  if (order) {
    return data.sort((a, b) => sumValues(a) - sumValues(b));
  } else {
    return data.sort((a, b) => sumValues(b) - sumValues(a));
  }
};

export const colorsArray = [
  "#690277",
  "#188bf6",
  "#a1d1ff",
  "#7450ba",
  "#a0a6d8",
  "#191970",
  "#2f4f4f",
  "#800000",
  "#696969",
  "#00ffff",
  "#4b0082",
  "red",
  "yellow",
  "green",
  "black",
  "orange",
];

export const sortActivitiesSalesRep = (salesRep) =>
  salesRep.sort((a, b) => (a.username || "").localeCompare(b.username || ""));

// export const sortActivityTypes = (data) =>
export const sortDepartments = (data) =>
  data.sort((a, b) =>
    // (a.activity_type || "").localeCompare(b.activity_type || "")
    (a.department || "").localeCompare(b.department || "")
  );

export const requiredFeilds = [
  "document_date",
  "document_template_id",
  "document_status_id",
  "qty",
];

const columnNameAndError = [
  {
    dataIndex: "document_template_id",
    error: "Document Type is Required!",
  },
  {
    dataIndex: "document_status_id",
    error: "Status is Required!",
  },
  {
    dataIndex: "document_due_date",
    error: "Due Date is Required!",
  },
  {
    dataIndex: "qty",
    error: "Qty is Required!",
  },
];

export const getErrorText = (dataIndex) => {
  let items = columnNameAndError.filter((el) => el.dataIndex === dataIndex);
  if (items.length > 0) {
    return items[0].error;
  } else return "";
};

export const shouldAllow = (el) => {
  const { name, isEdit, isSelect } = el;

  let isDate = moment(name)?.isValid() || false;
  let isNumber = name >= 0;
  let isString = (name || "").length > 0;

  let allow = !isSelect && (isNumber || isDate || isString);

  return allow;
};

export const labStockFilterOptions = [
    { label: "", value: "" },
];

export const distOptions = [
  { label: "Stock Code", value: "stockCode" },
  { label: "Stock Description", value: "stockDescription" },
  { label: "Lot No", value: "lotNo" },
  { label: "Scanned Code", value: "scannedCode" },
  { label: "Barcode", value: "barCode" },
];

export const stockTakeFilterOptions = distOptions;

export const attachOptions = [
  {
    label: "Has Attach",
    value: true,
  },
  {
    label: "No Attach",
    value: false,
  },
];

export const getOptions = (all, checkedList) => {
  let checkedlist = [];
  let unCheckedlist = [];

  all.forEach((el) =>
    checkedList.includes(el?.value)
      ? checkedlist.push(el)
      : unCheckedlist.push(el)
  );

  return [...checkedlist.sort(), ...unCheckedlist];
};

export const getExpiryColor = (expiryDate) => {
  if (!expiryDate) return null;
  const expiry = moment(expiryDate);
  if (!expiry || !expiry.isValid()) return null;
  
  const now = moment().startOf('day');
  const monthsRemaining = expiry.diff(now, 'months', true);

  if (monthsRemaining <= 1) {
    return "yellow";
  } else if (monthsRemaining <= 6) {
    return "blue";
  }
  return null;
};
